import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    const w = window as unknown as { __reportError?: (e: unknown, ctx?: unknown) => void }
    w.__reportError?.(error, { componentStack: info.componentStack })
  }

  private handleReload = (): void => {
    window.location.reload()
  }

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          textAlign: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          color: '#1f1f1f',
        }}
      >
        <h1 style={{ fontSize: '20px', marginBottom: '8px' }}>Что-то пошло не так</h1>
        <p style={{ fontSize: '14px', color: '#6b6b6b', marginBottom: '24px' }}>
          Попробуйте перезагрузить приложение
        </p>
        <button
          onClick={this.handleReload}
          style={{
            padding: '12px 24px',
            background: '#c2410e',
            color: '#fff',
            border: 'none',
            borderRadius: '12px',
            fontSize: '16px',
            cursor: 'pointer',
          }}
        >
          Перезагрузить
        </button>
      </div>
    )
  }
}
